import { Box, Button, Card, CardMedia, Stack, Typography } from "@mui/material";
import React from "react";
import cardData from "./cardData";
import { useNavigate } from "react-router-dom";
const CardSection = () => {
  const navigate = useNavigate();
  const slugify = (title) =>
    title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  const handleClick = (index, title) => {
    console.log("cardInfo:",index,title);
    const slug = slugify(title);
    navigate(`/industries-component/${slug}`, { state: { index } });
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        // justifyContent: "center",
        gap: 3,
        // padding: 4,
        // border: "1px solid red",
      }}
    >
      {cardData.map((card) => (
        <Card
          key={card.card_id}
          sx={{
            width: { xs: "100%", sm: "280px" },
            borderRadius: 3,
            boxShadow: 3,
            overflow: "hidden",
            // border: "1px solid red",
            position: "relative", // 🔥 Needed for badge positioning
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "12px",
              right: "-40px",
              backgroundColor:
                card.badge === "Premium"
                  ? "#6a1b9a"
                  : card.badge === "Upcoming"
                  ? "#f57c00"
                  : "red", // default for "New"
              color: "white",
              px: 1.5,
              py: 0.5,
              fontSize: "12px",
              fontWeight: "bold",
              transform: "rotate(45deg)",
              zIndex: 10,
              width: "120px",
              textAlign: "center",
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
          >
            {card.badge}
          </Box>

          {/* Image */}
          <CardMedia
            component="img"
            height="180"
            image={card.img}
            alt={card.title}
          />

          {/* Content */}
          <Stack spacing={2} p={2}>
            <Typography variant="h6" fontWeight="bold">
              {card.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {card.description}
            </Typography>
            <Button
              variant="contained"
              sx={{ width: "fit-content", alignSelf: "flex-start" }}
              //  onClick={() => handleClick(card.card_id - 1)}
              onClick={() => handleClick(card.card_id - 1, card.title)}
            >
              Explore
            </Button>
          </Stack>
        </Card>
      ))}
    </Box>
  );
};

export default CardSection;
